import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './Icons';
import { fetchAnnouncements } from '../../utils/programData';
import { getProgram } from '../../config/programs';

// ── Matangazo & Ratiba ─────────────────────────────────────────────────
// Widget inayoonyesha kinachokuja: matukio, activity na matangazo.
// Inatumika kwenye dashboard ya Staff, ya Admin, na kwenye Program Hub.

const TYPE_META = {
  tangazo:  { label: 'Tangazo',  color: '#1565C0', icon: 'info' },
  event:    { label: 'Tukio',    color: '#E07A2E', icon: 'calendar' },
  activity: { label: 'Activity', color: '#00695C', icon: 'bolt' },
};

export default function AnnouncementsWidget({ limitTo = 5, programId }) {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [programId]);

  async function load() {
    try {
      const all = await fetchAnnouncements();
      const today = new Date().toISOString().split('T')[0];
      const upcoming = all
        .filter(a => !a.date || a.date >= today)
        .filter(a => !programId || a.programId === programId || a.programId === 'all' || !a.programId)
        .sort((a, b) => (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0) || (a.date || '').localeCompare(b.date || ''))
        .slice(0, limitTo);
      setItems(upcoming);
    } catch (err) { console.error(err); }
    setLoading(false);
  }

  if (loading) return null;

  return (
    <div style={styles.card}>
      <div style={styles.head}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Icon name="bolt" size={16} color="#E07A2E" />
          <span style={styles.title}>Matangazo & Ratiba</span>
        </div>
        <span onClick={() => navigate('/announcements')} style={styles.link}>Zote →</span>
      </div>

      {items.length === 0 ? (
        <div style={styles.empty}>
          Hakuna tangazo au tukio lililopangwa kwa sasa.
          <div onClick={() => navigate('/announcements')} style={{ ...styles.link, marginTop: '8px' }}>
            + Weka tangazo
          </div>
        </div>
      ) : items.map(a => {
        const meta = TYPE_META[a.type] || TYPE_META.tangazo;
        const prog = a.programId && a.programId !== 'all' ? getProgram(a.programId) : null;
        return (
          <div key={a.id} style={styles.row} onClick={() => navigate('/announcements')}>
            <div style={{ ...styles.dot, background: `${meta.color}18` }}>
              <Icon name={meta.icon} size={14} color={meta.color} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={styles.rowTitle}>
                {a.pinned && <span style={{ color: '#E07A2E' }}>★ </span>}
                {a.title}
              </div>
              <div style={styles.rowMeta}>
                <span style={{ color: meta.color, fontWeight: 700 }}>{meta.label}</span>
                {a.date && <> · {a.date}</>}
                {a.time && <> · {a.time}</>}
                {prog && <> · {prog.short}</>}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

const styles = {
  card: {
    background: '#fff', borderRadius: '16px', border: '1px solid #E8E4DA',
    padding: '16px 18px', marginBottom: '16px',
    fontFamily: "'Plus Jakarta Sans', sans-serif",
  },
  head: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' },
  title: { fontSize: '13.5px', fontWeight: 800, color: '#14452F' },
  link: { fontSize: '11.5px', fontWeight: 700, color: '#E07A2E', cursor: 'pointer' },
  empty: { fontSize: '12.5px', color: '#6B7280', padding: '10px 0', lineHeight: 1.6 },
  row: {
    display: 'flex', gap: '11px', alignItems: 'flex-start',
    padding: '10px 0', borderTop: '1px solid #F3F1EB', cursor: 'pointer',
  },
  dot: {
    width: '30px', height: '30px', borderRadius: '9px', flexShrink: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  rowTitle: { fontSize: '13px', fontWeight: 700, color: '#1A1A1A', lineHeight: 1.4 },
  rowMeta: { fontSize: '11px', color: '#6B7280', marginTop: '3px' },
};
